module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-fade-in-down/wow-fade-in-down.component.scss
// module id = ./src/app/features/wow-slider/wow-fade-in-down/wow-fade-in-down.component.scss
// module chunks = main